import React from 'react';
import logo from "../logos/logo.svg";

const Welcome = () => {
  return (
    <div className="welcome-content">
       <img src={logo} alt="Logo" className="thank-you-app-logo" />
        <p>Hirdess vagy Jelentkezz egyszerűen!</p>
    </div>
  );
};

export default Welcome;
